export default "__VITE_ASSET__BHfLFrYz__"